
import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { POLTERSORRY } from '../interface/interface';

@Pipe({
    name: 'contentSlice',
    standalone: false
})
export class ContentSlicePipe implements PipeTransform {

  transform(value: string | null | undefined, ...args: number[]): string {
    if (!value) {
      return '-';
    }

    if (value == environment.POL_TREASURY_WALLET) {
      return POLTERSORRY;
    }

    if (value.startsWith('0x') && value.length > 10) {
      return value.slice(args[0], args[1]) + '...' + value.slice(value.length - args[1]);
    }

    return value;
  }

}
